export default __webpack_public_path__ + "static/media/EN.4839cec4.svg";